import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Button from "../component/button/Button";
import InputOutline from "../component/input/InputOutline";
import AlertSuccess from "../component/alert/AlertSuccess";
import AlertFailed from "../component/alert/AlertFailed";
import logo from "../img/logo/logo-mosyapay.png";
import { urlApi } from "../setting/Url";
import { motion } from "framer-motion";
import { useDarkMode } from "../hooks/useDarkMode";

const LoginAdmin = () => {
    let navigate = useNavigate();
    useDarkMode();

    const [data, setData] = useState({
        username: "",
        password: "",
    });

    const [loadButton, setLoadButton] = useState(false);
    const [showNotif, setShowNotif] = useState(null);
    const [msgNotif, setMsgNotif] = useState({
        messageResponse: "",
        messageApi: "",
    });

    const form = useRef(null);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const submitFormLogin = (e) => {
        e.preventDefault();

        setLoadButton(true);

        const dataForm = new FormData(form.current);

        // use fetch API for cek data
        fetch(`${urlApi}/api/admin/login`, {
            method: "POST",
            body: dataForm,
        })
            .then((response) => response.json())
            .then((teks) => {
                if (teks.success) {
                    window.localStorage.setItem(
                        "logged_in",
                        teks.data.logged_in
                    );
                    window.localStorage.setItem("token", teks.token);

                    setData({
                        username: "",
                        password: "",
                    });

                    setLoadButton(false);

                    navigate("/HomeAdmin");
                } else if (teks.status === 404) {
                    setLoadButton(false);
                    setShowNotif(false);

                    const messageData = {
                        messageResponse: teks.messages.error,
                        messageApi: "Anda gagal login!",
                    };

                    setMsgNotif(messageData);
                } else if (teks.status === 400) {
                    setLoadButton(false);
                    setShowNotif(false);

                    const messageData = {
                        messageResponse: teks.messages.error,
                        messageApi: "Anda gagal login!",
                    };

                    setMsgNotif(messageData);
                }
            });
    };

    return (
        <motion.div
            className=" w-full bg-white dark:bg-black_m-300 h-screen flex justify-center relative overflow-hidden"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ duration: 0.4 }}
        >
            <div className="h-[calc(100%-450px)] absolute top-0 flex flex-col justify-center">
                <div className="bg-white_m-200 shadow-lg shadow-gray-200 w-[120px] h-[120px] sm:w-[140px] sm:h-[140px] dark:shadow-black_m-400 rounded-[50px] flex justify-center items-center">
                    <img src={logo} alt="logo MosyaPay" width="60" />
                </div>
                <h1 className="font-pop text-base text-center mt-2 text-black_m-200 dark:text-white_m-100">
                    MosyaPay
                </h1>
            </div>
            <div className="w-full h-[450px] bg-white_m-200 dark:bg-black absolute bottom-0 rounded-t-3xl shadow-2xl dark:shadow-black_m-400 px-[50px]">
                <div className="flex flex-col mt-5 mb-5">
                    <h2 className="box-login__title">Login</h2>
                </div>
                <div className="flex flex-col justify-around">
                    <form ref={form} onSubmit={submitFormLogin}>
                        <div className="mb-2">
                            <label htmlFor="username" className="label-login">
                                Username
                            </label>
                            <InputOutline
                                type="text"
                                name="username"
                                change={handleChange}
                            ></InputOutline>
                        </div>
                        <div className="mb-6">
                            <label htmlFor="password" className="label-login">
                                Password
                            </label>
                            <InputOutline
                                type="password"
                                name="password"
                                change={handleChange}
                            ></InputOutline>
                        </div>
                        <Button loading={loadButton} type="submit">
                            Login
                        </Button>
                    </form>
                </div>
            </div>
            {showNotif ? (
                <AlertSuccess
                    text={msgNotif.messageResponse}
                    apiText={msgNotif.messageApi}
                    notif={setShowNotif}
                />
            ) : showNotif === false ? (
                <AlertFailed
                    text={msgNotif.messageResponse}
                    apiText={msgNotif.messageApi}
                    notif={setShowNotif}
                />
            ) : (
                ""
            )}
        </motion.div>
    );
};

export default LoginAdmin;
